import React, {useState} from "react";

import {useTranslation} from "react-i18next";
import {queries} from "shared/api/queries";
import client from "api/client";
import {DraggableModal} from "shared/ui/modal/draggableModal";
import {ContainerEnum} from "shared/types";
import {Radio, useToast} from "shared/ui";
import {getApiErrorMsg} from "shared/lib/fns";
import {LoadingSpinner} from "shared/assets/svgs/LoadingSpinner";
import {TCreatePlanAPIData} from "../../types";


interface Props {
  planNo: string | null;
  planDate: string | null;
  trackingNumbers: string[];
  onCreated: () => void;
  onHide: () => void;
}

export const CreatePlanPopup = ({
                                  onCreated, onHide, trackingNumbers, planNo, planDate,
                                }: Props) => {
  const {t} = useTranslation("shipping");
  const toast = useToast();
  const [selectedType, setSelectType] = useState<ContainerEnum>();
  const [isLoading, setIsLoading] = useState(false);
  
  const handleCreate = () => {
    if (!selectedType) {
      toast.warning(t("Please, select bunny type"));
    }
    else if (!planNo?.length) {
      toast.warning(t("Please, select plan no first"));
    }
    else if (!planDate?.length) {
      toast.warning(t("Please, select plan date first"));
    }
    else {
      setIsLoading(true);
      const data: TCreatePlanAPIData = {
        tracking_numbers: trackingNumbers, plan_no: planNo,
        bunny_color: selectedType, plan_date: planDate
      };
      client
      .post(queries.plan.create, data)
      .then(() => {
        onHide();
        onCreated();
      })
      .catch((error) => toast.error(getApiErrorMsg(error)))
      .finally(() => {
        setIsLoading(false);
      });
    }
  };
  
  return (<DraggableModal
    width={305}
    onClose={onHide}
    showCancel
    cancelText={t("popup.btn.back")}
    onConfirm={handleCreate}
    confirmText={t("shipping.status.btn.create.plan")}
    title={t("Plan bunny type")}
  >
    <Radio.Group
      onChange={(e: any) => setSelectType(e.target.value)}
      className={"plan-radio"}
      name="radiogroup"
    >
      <Radio
        style={{marginTop: "6px"}}
        className={"item"}
        value={ContainerEnum.BLACK}
      >
        {ContainerEnum.BLACK}
      </Radio>
      
      <Radio
        className={"item"}
        value={ContainerEnum.BLUE}
      >
        {ContainerEnum.BLUE}
      </Radio>
      
      <Radio
        className={"item"}
        value={ContainerEnum.WHITE}
      >
        {ContainerEnum.WHITE}
      </Radio>
      
      <Radio
        className={"item"}
        value={ContainerEnum.OFFROAD}
      >
        {ContainerEnum.OFFROAD}
      </Radio>
      
      <Radio
        className={"item"}
        value={ContainerEnum.RAINBOW}
      >
        {ContainerEnum.RAINBOW}
      </Radio>
      
      <Radio
        className={"item"}
        value={ContainerEnum.YELLOW}
      >
        {ContainerEnum.YELLOW}
      </Radio>
      
      <Radio
        className={"item"}
        value={ContainerEnum.ORANGE}
      >
        {ContainerEnum.ORANGE}
      </Radio>
    </Radio.Group>
    {isLoading && (<LoadingSpinner className={"spinner"} />)}
  </DraggableModal>);
};
